import {
  AYANA_RESORT_AND_SPA,
  RIMBA_JIMBARAN_BALI,
  VILLAS_AYANA_RESORT_BALI,
  AYANA_SEGARA_BALI,
} from "store/constants/hotel";
const HOTELS = {
  [AYANA_RESORT_AND_SPA]: "/bali/ayana-resort-and-spa",
  [RIMBA_JIMBARAN_BALI]: "/bali/rimba-jimbaran",
  [VILLAS_AYANA_RESORT_BALI]: "/bali/the-villas-at-ayana",
  [AYANA_SEGARA_BALI]: "/bali/ayana-segara",
};

export default HOTELS;
